import Vue from 'vue'
import { loadMicroApp } from 'qiankun'
import router from '@/router'
import store from '@/store'
import { flatten, curry } from 'lodash'
import { config, startConfig } from '@/microAppsConfig'

const isPro = true

export async function startMicroApp(subSys, isLogin) {
  let { route: path } = subSys
  if (path.endsWith('/')) path = path.replace(/\/$/, '')// 如果path以/结尾，则去掉
  const list = config?.map(item => item.path)
  const registedList = flatten(list)
  const subPath = (isPro && !path.match(/^\/ucs\//)) ? `/ucs${path}` : path
  const locationOrigin = document.location.origin
  if (!registedList?.includes(subPath)) {
    window.open(`${isPro ? locationOrigin : process.env.VUE_APP_API_DOMAIN}${path}`, '_blank')
    const loginPath = '/ucs/login/page'
    const pathname = window.location.pathname
    if (pathname === loginPath) {
      await router.push('/')
    }
    return
  }
  // saveSubApp(subSys)
  // 由于没办法解决管理中心的路由对象影响的问题。所以就直接用以下跳转子应用
  // window.location.href = `${locationOrigin}${subPath}`
  if (isLogin) {
    // 由于没有办法解决 store 需要重载的问题的临时解决方案
    window.location.href = `${locationOrigin}${subPath}`
    saveSubApp(subSys)
  } else {
    await router.push(path)
  }
}

export function saveSubApp(subSys) {
  const { mobile } = store.getters
  const { $ls, $cookie } = Vue.prototype
  let subApp = $ls.get(`sub-app_${mobile}`)
  subApp = {
    ...subApp,
    [mobile]: subSys
  }
  $cookie.set('systemName', subSys.code)
  $ls.set(`sub-app_${mobile}`, subApp)
}

export async function toMicroApp (to) {
  const { path } = to
  const realPath = (!path.match(/^\/ucs\//)) ? `/ucs${path}` : path
  if (currentConfig(config, to.path)) {
    let { systemList } = store.getters
    if (!systemList.length) {
      systemList = await store.dispatch('GetSystemList')
    }
    const currentSystem = findCurrentSystem(systemList, realPath)
    if (!currentSystem) return
    saveSubApp(currentSystem)
    await loadApp(to)
  } else {
    await router.push('/')
  }
}

async function loadApp (to) {
  const { microApps } = store.getters
  const { path } = to
  // const currentApp = config.find(item => path.includes(item.activeRule))

  const currentApp = currentConfig(config, path)
  const { name } = currentApp
  let subApp = microApps?.[name]?.app
  if (!subApp) {
    subApp = await loadMicro(currentApp)
    store.commit('SET_MICRO_APPS', {
      ...microApps,
      [name]: {
        app: subApp,
        config: currentApp,
        children: []
      }
    })
  } else {
    subApp = await waitSubApp(subApp)
    microApps[name].app = subApp
  }
  store.commit('SET_SHOW_MICRO_APP', name)
  // await subApp.mountPromise.catch(async err => {
  //   console.error(err)
  //   store.commit('SET_MICRO_APP_LOADING', false)
  //   store.commit('SET_SHOW_MICRO_APP', '')
  //   return await router.replace({ name: 'notFound' })
  // })
  if (typeof subApp?.update === 'function') {
    await subApp.update({ to, ...currentApp.props })
  }
  setAppState()
  // await next()
}

// 加载子应用及其意外处理方法封装
async function loadMicro (currentApp) {
  store.commit('SET_MICRO_APP_LOADING', true)
  let subApp = await loadMicroApp(currentApp, startConfig)
  subApp = await waitSubApp(subApp, currentApp)
  if (!subApp) return
  return subApp
}

// 等待应用加载完成，出错并重新加载
async function waitSubApp (subApp, currentApp) {
  await Promise.all([subApp.bootstrapPromise, subApp.loadPromise, subApp.mountPromise])
    .catch(async err => {
      console.error(err)
      store.commit('SET_MICRO_APP_LOADING', false)
      store.commit('SET_SHOW_MICRO_APP', '')
      await router.replace({ name: 'notFound' })
      return false
    })
  const status = subApp.getStatus()
  console.log('当前应用的状态', status)
  switch (status) {
    case 'NOT_LOADED':
    case 'LOAD_ERROR':
      subApp = await loadMicro(currentApp)
      break
    case 'NOT_MOUNTED':
      subApp = await subApp.mount()
      break
    default:
      break
  }
  return subApp
}

// 卸载不再使用的子应用
async function setAppState () {
  const { microApps, showMicroApp } = store?.state?.tabs || {}
  for (const name in microApps) {
    const app = microApps[name]
    if (name !== showMicroApp && !app?.children?.length && typeof app?.unmount === 'function') {
      await app.unmount()
    }
  }
}

// 根据路径判断当前子系统数据
function findCurrentSystem (systemList, realPath, isRoutePath = false) {
  const realPathArr = realPath.split('/')
  return systemList.find(item => {
    const { route } = item
    const routeArr = route.split('/')
    return (isPro && !isRoutePath) ? (routeArr[1] === realPathArr[2]) : (routeArr[1] === realPathArr[1])
    // realPath.includes(item.route)
  })
}

// 根据路径判断当前子应用配置
export function currentConfig (config, path) {
  path = (isPro && !path.match(/^\/ucs\//)) ? `/ucs${path}` : `${path}`
  const pathArr = path.split('/')
  return config.find(item => {
    const { path: itemPath } = item
    const itemPathArr = itemPath.split('/')
    return isPro ? (itemPathArr[2] === pathArr[2]) : (itemPathArr[1] === pathArr[1])
  })
}

// 柯里化判断当前子应用配置
export const curriedConfig = curry(currentConfig)

/**
 * 提供给子应用的方法
 */
// 添加主应用头部标签条目
export function mainAddTab (appName, route) {
  const { path: originPath, meta } = route || {}
  const { microApps } = store.getters
  let { children: currentChildren } = microApps[appName] || {}
  let { title } = meta || {}
  if (!title) return
  if (appName === 'agent' && title === '首页') {
    title = '微海灵心'
  }
  const path = `/${appName}${originPath}`
  const tab = {
    ...route,
    path,
    title,
    appName,
    originPath
  }
  if (!currentChildren) currentChildren = {}
  store.commit('SET_MICRO_APP_CHILDREN', {
    appName,
    children: [...currentChildren, route]
  })
  if (title === '首页') return
  store.commit('ADD_TAB', tab)
}

// 更新主应用头部标签条目
export function mainUpdateTab (appName, route) {
  const { path: originPath, meta } = route || {}
  const { microApps } = store.getters
  const { children: currentChildren } = microApps[appName]
  const { title } = meta || {}
  if (!title) return
  let path = '/'
  console.log(appName, originPath)
  path = `/${appName}${originPath}`
  const tab = {
    ...route,
    path,
    title,
    appName,
    originPath
  }
  store.commit('SET_MICRO_APP_CHILDREN', {
    appName,
    children: [...currentChildren, route]
  })
  if (title === '首页') return
  store.commit('UPDATE_TAB', tab)
}

// 移除子应用头部标签条目
export async function mainRemoveTab (appName, params) {
  // const { microApps } = store.getters
  const { tabs } = store.state.tabs
  const path = typeof params === 'object' ? params.path : params
  // const { children: currentChildren } = microApps[appName]
  console.log(appName, path)
  const resPath = appName ? `/${appName}${path}` : path
  const tab = tabs.find(item => item.path === resPath)
  // const children = currentChildren.filter(item => item.path !== path)
  if (!tab) return true
  return await store.dispatch('removeTab', { ...params, ...tab })
  // store.commit('SET_MICRO_APP_CHILDREN', { appName, children })
}

// 跳转到主应用页面方法
export async function mainRouterPush (route) {
  if (!route) {
    return await router.push('/')
  }
  return await router.push(route)
}

// 跳转到子应用页面方法
export async function microRouterPush (appName, route) {
  console.log(route)
  const isObjRoute = route && typeof route === 'object'
  const appConf = config.find(item => (item.name === appName || item.code === appName))
  if (!appConf) return Vue.prototype.$message.error('没有找到相关应用！')
  route = isObjRoute ? {
    ...route,
    path: `${appConf.rootPath}${route.path || '/'}`
  } : `${appConf.rootPath}${route || '/'}`
  console.log(route)
  await router.push(route)
}

// 子应用跳转前判断，做一些权限方面的跳转拦截
export function microAppInterception (to, next) {
  const { path } = to
  const { systemList } = store.getters
  const current = findCurrentSystem(systemList, path, true)
  if (!current) return true // 没有找到子应用，说明是主应用或者是未注册的应用，不用处理返回 true，继续往下走
  const { stopFlag } = current
  // 判断应用是否过期
  if (+stopFlag === 2) {
  // if (!stopFlag) {
    Vue.prototype.$error({
      title: '提示',
      content: '您的应用授权已过期，请联系管理员！',
      okText: '知道了',
      onOk () {
        next('/')
      }
    })
    return false
  }
  return true
}
